import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const CtaBand = ({ t }) => (
  <section className="cta-band grain" data-testid="cta-band">
    <div className="wrap cta-band-inner">
      <Reveal>
        <p className="eyebrow lt mono-label">{t.contactLabel}</p>
        <h2 className="cta-band-title">{t.ctaBandTitle}</h2>
      </Reveal>
      <Reveal delay={0.15}>
        <motion.a
          href="#contact"
          className="cta-circle"
          aria-label={t.cta}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.95 }}
          data-testid="cta-band-btn"
        >
          <span>↗</span>
        </motion.a>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
